// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var DisconnectType;
(function (DisconnectType) {
    DisconnectType[DisconnectType["Unspecified"] = 0] = "Unspecified";
    DisconnectType[DisconnectType["DisconnectedByServer"] = 1] = "DisconnectedByServer";
    DisconnectType[DisconnectType["ConnectionLost"] = 2] = "ConnectionLost";
    DisconnectType[DisconnectType["DisconnectedByClient"] = 3] = "DisconnectedByClient";
})(DisconnectType || (DisconnectType = {}));
export var DisconnectLevel;
(function (DisconnectLevel) {
    DisconnectLevel[DisconnectLevel["Unspecified"] = 0] = "Unspecified";
    DisconnectLevel[DisconnectLevel["ConsoleToJava"] = 1] = "ConsoleToJava";
    DisconnectLevel[DisconnectLevel["AspToConsole"] = 2] = "AspToConsole";
    DisconnectLevel[DisconnectLevel["JavascriptToAsp"] = 3] = "JavascriptToAsp";
    DisconnectLevel[DisconnectLevel["CloseSocket"] = 4] = "CloseSocket";
})(DisconnectLevel || (DisconnectLevel = {}));
export var ConnectionErrorsEnum;
(function (ConnectionErrorsEnum) {
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_NONE"] = 0] = "ERROR_NONE";
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_NEED_ACTIVATION"] = 1] = "ERROR_NEED_ACTIVATION";
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_WRONG_ACTIVATION"] = 2] = "ERROR_WRONG_ACTIVATION";
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_INTERNAL"] = 3] = "ERROR_INTERNAL";
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_MAINTENANCE"] = 4] = "ERROR_MAINTENANCE";
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_USER_BLOCKED"] = 5] = "ERROR_USER_BLOCKED";
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_MULTI_POLICY"] = 6] = "ERROR_MULTI_POLICY";
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_NOT_ALLOWED"] = 7] = "ERROR_NOT_ALLOWED";
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_USER_NOT_FOUND"] = 8] = "ERROR_USER_NOT_FOUND";
    ConnectionErrorsEnum[ConnectionErrorsEnum["INVALID_LOGIN_PASSWORD_COMBINATION"] = 9] = "INVALID_LOGIN_PASSWORD_COMBINATION";
    ConnectionErrorsEnum[ConnectionErrorsEnum["INVALID_BRANDING_KEY"] = 10] = "INVALID_BRANDING_KEY";
    ConnectionErrorsEnum[ConnectionErrorsEnum["MAX_CONCURRENT_CONNECTIONS"] = 11] = "MAX_CONCURRENT_CONNECTIONS";
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_UNKNOWN"] = 13] = "ERROR_UNKNOWN";
    ConnectionErrorsEnum[ConnectionErrorsEnum["ERROR_NO_WORKING_SERVERS"] = 14] = "ERROR_NO_WORKING_SERVERS";
})(ConnectionErrorsEnum || (ConnectionErrorsEnum = {}));
export var RegistrationMode;
(function (RegistrationMode) {
    RegistrationMode[RegistrationMode["Blocked"] = 0] = "Blocked";
    RegistrationMode[RegistrationMode["Screen"] = 1] = "Screen";
    RegistrationMode[RegistrationMode["Link"] = 2] = "Link";
})(RegistrationMode || (RegistrationMode = {}));
